import React, { useRef, useState } from 'react'

type SubmitData = {
    price: string
    fio: string
    orgName: string
    orgINN: string
    posCount: number
    userCount: number
    email: string
    phone: string
}

const PricePage: React.FC = () => {
    const formRef = useRef<HTMLDivElement>(null)
    const [isSending, setSending] = useState(false)
    const [data, setData] = useState<SubmitData>({
        price: '-',
        fio: '',
        orgName: '',
        orgINN: '',
        posCount: 0,
        userCount: 0,
        email: '',
        phone: '',
    })

    const scrollToForm = () => {
        formRef.current?.scrollIntoView({ behavior: 'smooth' })
    }

    const isEmailValid = (email: string) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

    const formatPhoneNumber = (digits: string) => {
        const cleaned = digits.replace(/\D/g, '').slice(0, 11)
        const parts = cleaned.length < 1 ? [''] : ['+7']

        if (cleaned.length > 1) parts.push(` (${cleaned.slice(1, 4)}`)
        if (cleaned.length >= 5) parts.push(`) ${cleaned.slice(4, 7)}`)
        if (cleaned.length >= 8) parts.push(`-${cleaned.slice(7, 9)}`)
        if (cleaned.length >= 10) parts.push(`-${cleaned.slice(9, 11)}`)

        return parts.join('')
    }

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digits = e.target.value.replace(/\D/g, '')
        let newDigits = digits

        // always start with 7
        if (newDigits.startsWith('8')) newDigits = '7' + newDigits.slice(1)
        if (!newDigits.startsWith('7')) newDigits = '7' + newDigits

        setData({ ...data, phone: newDigits.slice(0, 11) })
    }

    const isFormValid =
        data.price !== '-' &&
        data.fio.trim() !== '' &&
        data.orgName.trim() !== '' &&
        data.orgINN.trim().length === 10 &&
        data.posCount > 0 &&
        data.userCount > 0 &&
        isEmailValid(data.email) &&
        data.phone.length === 11

    const handleSubmit = async () => {
        if (!isFormValid) return

        try {
            setSending(true)
            let apiUrl: string | undefined
            if (process.env.REACT_APP_MODE == 'site') {
                apiUrl = 'https://223.noxsys.ru'
            } else {
                apiUrl = process.env.REACT_APP_API_URL
            }
            const res = await fetch(
                apiUrl + '/api/backend/v1/mail_send/submit_price_request',
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                }
            )

            if (res.ok) {
                setSending(false)
                setData({
                    price: '-',
                    fio: '',
                    orgName: '',
                    orgINN: '',
                    posCount: 0,
                    userCount: 0,
                    email: '',
                    phone: '',
                })
                alert('Заявка успешно отправлена!')
            } else {
                setSending(false)
                alert('Ошибка при отправке заявки')
            }
        } catch (err) {
            console.error(err)
            setSending(false)
            alert('Ошибка соединения')
        }
    }

    return (
        <div className="flex flex-col w-full text-center items-center justify-start bg-[#f0f3f5] overflow-y-auto custom-scrollbar">
            <div className="flex w-full h-24"></div>

            <div className="flex flex-col w-full gap-24 items-center justify-center">
                <div className="flex flex-col w-full h-fit items-center justify-start gap-5">
                    <div className="flex flex-row w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px] gap-3">
                        <span>Тарифы</span>
                    </div>
                    <div className="flex flex-row w-[1200px] text-[16px]">
                        <div className="flex flex-col flex-1 items-start justify-center">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Возможности
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-start justify-center text-left leading-[18px] ">
                                    Срок лицензии
                                </div>
                                <div className="flex flex-col w-full h-14 items-start justify-center text-left leading-[18px] ">
                                    Экспорт действующих планов в систему
                                    (неограниченное количество позиций с 2020
                                    года)
                                </div>
                                <div className="flex flex-col w-full h-9 items-start justify-center text-left leading-[18px] ">
                                    Количество создаваемых планов закупки
                                </div>
                                <div className="flex flex-col w-full h-9 items-start justify-center text-left leading-[18px] ">
                                    Количество новых позиций отправляемых в ЕИС
                                </div>
                                <div className="flex flex-col w-full h-5 items-start justify-center text-left leading-[18px] ">
                                    Количество пользователей
                                </div>
                                <div className="flex flex-col w-full h-5 items-start justify-center text-left leading-[18px] ">
                                    Роли, структура организации
                                </div>
                                <div className="flex flex-col w-full h-5 items-start justify-center text-left leading-[18px] ">
                                    Согласование
                                </div>
                                <div className="flex flex-col w-full h-9 items-start justify-center text-left leading-[18px] ">
                                    Заказ разработки дополнительных функций
                                </div>
                                <div className="flex flex-col w-full h-5 items-start justify-center text-left leading-[18px] ">
                                    Стоимость
                                </div>
                                <div className="flex flex-col w-full h-8 items-start justify-center text-left leading-[18px] "></div>
                            </div>
                        </div>
                        {/* <div className="flex flex-col w-[150px] items-center justify-start">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Старт
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1 год
                                </div>
                                <div className="flex flex-col w-full h-14 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    200
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left font-bold uppercase leading-[18px] text-[#407bff]">
                                    Бесплатно
                                </div>
                                <div className="flex flex-col w-full items-center justify-center ">
                                    <button
                                        className="flex min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] border-2 border-[#5e6169] hover:bg-[#787b84] hover:border-[#787b84] hover:text-[#FFFFFF] duration-300 transform transition-all"
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                price: 'Старт',
                                            })
                                            scrollToForm()
                                        }}
                                    >
                                        Оставить заявку
                                    </button>
                                </div>
                            </div>
                        </div> */}
                        <div className="flex flex-col w-[150px] items-center justify-start">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Специалист
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1 год
                                </div>
                                <div className="flex flex-col w-full h-14 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    500
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center leading-[18px]">
                                    Рассчитывается индивидуально
                                </div>
                                <div className="flex flex-col w-full items-center justify-center ">
                                    <button
                                        className="flex min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] border-2 border-[#5e6169] hover:bg-[#787b84] hover:border-[#787b84] hover:text-[#FFFFFF] duration-300 transform transition-all"
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                price: 'Специалист',
                                            })
                                            scrollToForm()
                                        }}
                                    >
                                        Оставить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-[150px] items-center justify-start">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Эксперт
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1 год
                                </div>
                                <div className="flex flex-col w-full h-14 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    1000
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    2
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center leading-[18px]">
                                    Рассчитывается индивидуально
                                </div>
                                <div className="flex flex-col w-full items-center justify-center ">
                                    <button
                                        className="flex min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] border-2 border-[#5e6169] hover:bg-[#787b84] hover:border-[#787b84] hover:text-[#FFFFFF] duration-300 transform transition-all"
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                price: 'Эксперт',
                                            })
                                            scrollToForm()
                                        }}
                                    >
                                        Оставить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-[150px] items-center justify-start">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Команда
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1 год
                                </div>
                                <div className="flex flex-col w-full h-14 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    2000
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    5
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center leading-[18px]">
                                    Рассчитывается индивидуально
                                </div>
                                <div className="flex flex-col w-full items-center justify-center ">
                                    <button
                                        className="flex min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] border-2 border-[#5e6169] hover:bg-[#787b84] hover:border-[#787b84] hover:text-[#FFFFFF] duration-300 transform transition-all"
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                price: 'Команда',
                                            })
                                            scrollToForm()
                                        }}
                                    >
                                        Оставить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-[150px] items-center justify-start">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Индивидуальный
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1 год
                                </div>
                                <div className="flex flex-col w-full h-14 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    Индивидуально
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    Индивидуально
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        className="h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        className="h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    -
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center leading-[18px]">
                                    Рассчитывается индивидуально
                                </div>
                                <div className="flex flex-col w-full items-center justify-center ">
                                    <button
                                        className="flex min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] bg-[#5e6169] hover:bg-[#787b84] text-[#FFFFFF] duration-300 transform transition-all"
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                price: 'Индивидуальный',
                                            })
                                            scrollToForm()
                                        }}
                                    >
                                        Оставить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-[150px] items-center justify-start">
                            <div className="flex flex-col w-full h-[50px] items-center justify-center font-bold">
                                Премиум
                            </div>
                            <div className="flex flex-col w-full py-5 gap-5 items-center justify-center ">
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    1 год
                                </div>
                                <div className="flex flex-col w-full h-14 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left font-bold leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    ထ
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        className="h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        className="h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-9 items-center justify-center text-left leading-[18px] ">
                                    <svg
                                        className="h-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="check"
                                    >
                                        <path
                                            fill="#181818"
                                            d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"
                                        ></path>
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full h-5 items-center justify-center leading-[18px]">
                                    Рассчитывается индивидуально
                                </div>
                                <div className="flex flex-col w-full items-center justify-center ">
                                    <button
                                        className="flex min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] bg-[#5e6169] hover:bg-[#787b84] text-[#FFFFFF] duration-300 transform transition-all"
                                        onClick={() => {
                                            setData({
                                                ...data,
                                                price: 'Премиум',
                                            })
                                            scrollToForm()
                                        }}
                                    >
                                        Оставить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col w-full items-center justify-start gap-5">
                    <div className="flex flex-row w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px] gap-3">
                        <span>Бесплатно 1 месяц</span>
                    </div>
                    <div className="flex flex-row w-[1200px] gap-5">
                        <div className="flex flex-col flex-1 py-5 text-[38px] leading-[40px] font-bold items-center justify-center text-left">
                            Начните бесплатно и продолжайте с сохранением всех
                            данных
                        </div>
                        <div className="flex flex-col w-[230px] bg-[#e4e7ea] rounded-3xl p-5 items-start justify-start gap-3">
                            <div className="flex w-full text-[24px] font-bold text-left items-center justify-start ">
                                Демоверсия
                            </div>
                            <div className="flex w-full text-left text-[16px] leading-[18px] border border-[#181818">
                                При переходе на коммерческую версию все ваши
                                настройки и данные будут сохранены, чтобы вы
                                могли продолжить работу с максимальной
                                эффективностью
                            </div>
                        </div>
                        <div className="flex flex-col items-start justify-start gap-5">
                            <div className="flex flex-col w-[230px] text-left text-[16px] leading-[18px] bg-[#e4e7ea] rounded-3xl p-5 items-center justify-start">
                                Оцените все преимущества системы бесплатно
                            </div>
                            <div className="flex flex-col w-[230px] text-left text-[16px] leading-[18px] bg-[#e4e7ea] rounded-3xl p-5 items-center justify-start">
                                Система предоставляется в полнофункциональной
                                версии
                            </div>
                        </div>
                        <div className="flex flex-col w-[230px] bg-[#5e6169] text-[#FFFFFF] rounded-3xl p-5 gap-3 items-start justify-start ">
                            <div className="flex w-full text-[24px] font-bold text-left items-center justify-center ">
                                Сопровождение
                            </div>
                            <div className="flex flex-col w-full text-[14px] leading-[16px] items-center justify-center gap-5 ">
                                <div className="flex flex-col text-left">
                                    Предоставляем сопровождение и обучение на
                                    каждом этапе внедрения системы с
                                    персональным менеджером
                                </div>
                                <div className="flex flex-col text-left items-start justify-start">
                                    Бесплатная интеграция с ЕИС
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col w-full items-center justify-start gap-5">
                    <div className="flex flex-row w-[1200px] h-full items-center justify-start font-bold text-[48px] leading-[48px] gap-3">
                        <span>Уникальная возможность с тарифом Премиум</span>
                    </div>
                    <div className="flex flex-row w-[1200px] gap-5">
                        <div className="flex flex-col flex-1 py-5 text-[24px] leading-[26px] font-bold items-center justify-center text-left">
                            Разработаем на базе NOXSYS уникальное решение
                            подходящее только для вашей компании с тарифом
                            Премиум
                        </div>
                        <div className="flex flex-row flex-1 bg-[#e4e7ea] p-5 px-10 rounded-3xl gap-3 items-center justify-center">
                            <div className="flex flex-1 items-center justify-center text-left text-[16px] leading-[18px]">
                                Стоимость программного обеспечения определяется
                                исходя из технических потребностей пользователя
                                и используемого им функционала
                            </div>
                            <button
                                className="w-fit min-w-[120px] h-8 py-2 px-3 items-center justify-center rounded-[10px] text-[12.8px] bg-[#5e6169] hover:bg-[#787b84] text-[#FFFFFF]"
                                onClick={() => {
                                    setData({
                                        ...data,
                                        price: 'Премиум',
                                    })
                                    scrollToForm()
                                }}
                            >
                                Оставить заявку
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    ref={formRef}
                    className="flex w-full items-center justify-center"
                >
                    <div className="flex flex-row w-[1200px] bg-[#5e6169] items-center justify-center p-10 mb-10 rounded-3xl gap-10">
                        <div className="flex flex-col w-full h-full text-[#FFFFFF] text-left items-start justify-center gap-5">
                            <span className="flex items-start justify-center text-[38px] leading-[40px] font-bold text-left">
                                Поможем подключить и выбрать подходящий тарифный
                                план для вашей организации
                            </span>
                            <span className="flex items-start justify-center text-[16px] leading-[16px] text-left">
                                Для того, чтобы узнать стоимость, получить
                                доступ к демоверсии или купить систему,
                                отправьте заполненную форму и мы обязательно
                                свяжемся с вами!
                            </span>
                        </div>
                        <div className="flex flex-col w-full h-full items-center justify-start rounded-3xl bg-[#FFFFFF] p-10 gap-5 text-[12.8px]">
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Желаемый тарифный план
                                </label>
                                <select
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.price}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            price: e.target.value,
                                        })
                                    }}
                                >
                                    <option
                                        className="text-[#8A8A8A]"
                                        value={'-'}
                                        disabled
                                    >
                                        Выбрать
                                    </option>
                                    <option value="Старт">Старт</option>
                                    <option value="Специалист">
                                        Специалист
                                    </option>
                                    <option value="Эксперт">Эксперт</option>
                                    <option value="Команда">Команда</option>
                                    <option value="Индивидуальный">
                                        Индивидуальный
                                    </option>
                                    <option value="Премиум">Премиум</option>
                                </select>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Фамилия Имя Отчество
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.fio}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            fio: e.target.value,
                                        })
                                    }}
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Наименование организации
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.orgName}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            orgName: e.target.value,
                                        })
                                    }}
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    ИНН вашей организации
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    type="text"
                                    inputMode="numeric"
                                    pattern="\d*"
                                    maxLength={10}
                                    value={data.orgINN}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(
                                            /\D/g,
                                            ''
                                        )
                                        setData({
                                            ...data,
                                            orgINN: value.slice(0, 10),
                                        })
                                    }}
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Количество позиций плана закупки
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    type="text"
                                    inputMode="numeric"
                                    pattern="\d*"
                                    value={
                                        data.posCount == 0 ? '' : data.posCount
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value.replace(
                                            /\D/g,
                                            ''
                                        )
                                        setData({
                                            ...data,
                                            posCount: Number(value),
                                        })
                                    }}
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Количество пользователей
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    type="text"
                                    inputMode="numeric"
                                    pattern="\d*"
                                    value={
                                        data.userCount == 0
                                            ? ''
                                            : data.userCount
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value.replace(
                                            /\D/g,
                                            ''
                                        )
                                        setData({
                                            ...data,
                                            userCount: Number(value),
                                        })
                                    }}
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Адрес электронной почты
                                </label>
                                <input
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg items-center justify-start focus:outline-none text-[16px]"
                                    value={data.email}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            email: e.target.value,
                                        })
                                    }}
                                    placeholder="E-mail"
                                ></input>
                            </div>
                            <div className="flex flex-col w-full h-full items-center justify-start gap-1">
                                <label className="flex text-[#8A8A8A] w-full h-full items-center justify-start">
                                    Контактный телефон
                                </label>
                                <input
                                    value={formatPhoneNumber(data.phone)}
                                    onChange={handlePhoneChange}
                                    inputMode="numeric"
                                    maxLength={18}
                                    className="flex border border-[#8A8A8A] w-full h-[40px] p-2 rounded-lg focus:outline-none text-[16px]"
                                    placeholder="+7 (___) ___-__-__"
                                />
                            </div>
                            <button
                                className={`flex flex-col w-full h-[50px] items-center justify-center border-2 rounded-lg text-[16px] ${isFormValid ? 'bg-[#5e6169] hover:bg-[#6a6e76] text-[#FFFFFF] border-[#5e6169]' : 'bg-gray-300 text-gray-500 border-gray-300'}`}
                                onClick={() => {
                                    if (isFormValid) handleSubmit()
                                }}
                                disabled={!isFormValid}
                            >
                                {isSending ? (
                                    <svg
                                        className="animate-spin h-5 w-5 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Отправить'
                                )}
                            </button>
                            <div className="flex flex-col w-full items-center justify-center text-[#8A8A8A] leading-[14px]">
                                <div>
                                    Заполняя форму, вы соглашаетесь на обработку
                                    персональных данных в соответствии с{' '}
                                    <a
                                        className="text-sky-600 hover:text-sky-400"
                                        href="#/docs/privacy-policy"
                                        target="_blank"
                                    >
                                        политикой конфиденциальности
                                    </a>{' '}
                                    <br /> и получение информационных сообщений
                                    от ООО «Технологии Закупок»{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PricePage
